let navIcon = document.querySelector("#nav_icon");
let mobManuClose = document.querySelector("#mob_manu_close");
let headerInner = document.querySelector(".header-inner-wrapper");
let mobileMenu = document.querySelector(".mobile-menu-container");
let menuSubBtn = document.querySelectorAll(".menu-sub-btn");
let mobSubmenuBack = document.querySelectorAll(".mob-submenu-back");
let btnMobnavClose = document.querySelectorAll(".btn-mobnav-close");
let desktopSubmenuClose = document.querySelectorAll(".submenu-close button");
let destopNav = document.querySelectorAll(".desktop-nav .has-submenu");
let directsubmenu = document.querySelectorAll(".submenu-link a");
let countrySelectDeskBtn = document.querySelectorAll(".mob-country-selector a");
let mobLangSelectorBtn = document.getElementById("mob_lang_selector");
let getActiveLink = document.querySelectorAll(".active-nav");

// nav open
navIcon.addEventListener("click", function(){
    this.style.display= "none";
    headerInner.classList.add("open");
    mobileMenu.classList.add("open");
    document.body.classList.add("mob_scroll_lock");
});

// close nav bar
mobManuClose.addEventListener("click", function(){
    document.body.classList.remove("mob_scroll_lock");
    closeNav();
});

// nav back 
for (var i = 0; i < mobSubmenuBack.length; i++) {
    mobSubmenuBack[i].addEventListener("click", function() {
    let grandParent = this.closest(".grand-mob-submenu-container");
    let parent = this.closest(".mob-submenu-container");
    if(grandParent){
        checkVisible(grandParent);
    }else{
        checkVisible(parent);
    }
  });
}
// open mobile submenu
for (var i = 0; i < menuSubBtn.length; i++) {
    menuSubBtn[i].addEventListener("click", function() {
    let panel = this.nextElementSibling;

    checkVisible(panel);
  });
}

// close mobile nav from submenu
for (var i = 0; i < btnMobnavClose.length; i++) {
    btnMobnavClose[i].addEventListener("click", function() {
    let parent = this.closest(".mob-submenu-container");
    mobileMenu.classList.remove("open");
    document.body.classList.remove("mob_scroll_lock");

    checkVisible(parent);
    closeNav()
  });
}

// check element is visible or not
function checkVisible(item){
    if (item.style.display === "block") {
        item.style.display = "none";
        if(item.classList.contains("grand-mob-submenu-container")){
            headerInner.classList.remove("open");
        }else{
            headerInner.classList.add("open");
            mobileMenu.classList.remove("submenu-opened");
        }
    } else {
        item.style.display = "block";
        headerInner.classList.remove("open");
        mobileMenu.classList.add("submenu-opened");
    }
}

// close navication 
window.closeNav = function closeNav(){
    navIcon.style.display = "block";
    headerInner.classList.remove("open");
    mobileMenu.classList.remove("open");
}

// close submenu desktop after hover
for (let i = 0; i < desktopSubmenuClose.length; i++) {
    const element = desktopSubmenuClose[i];
    element.addEventListener("click", function(){
        let parent = this.closest(".desktop-submenu");
        parent.classList.remove("open");
    })
}

//megamenu hover desktop
for (let i = 0; i < destopNav.length; i++) {
    const element = destopNav[i];
    let submenuOverlay = document.querySelector(".desktop-menu-overlay");
    element.onmouseover = function(){
        let submenu = this.querySelector(".desktop-submenu");
        submenu.classList.add("open");
        submenuOverlay.classList.remove("hide");
    };
    element.onmouseout = function(){
        let submenu = this.querySelector(".desktop-submenu");
        submenu.classList.remove("open");
        submenuOverlay.classList.add("hide");
    };
}

//open submenu when clicked on whole menu link mobile
for (let i = 0; i < directsubmenu.length; i++) {
    const element = directsubmenu[i];
    element.addEventListener("click",function(e){
        let buttonClick = element.nextElementSibling;
        if(buttonClick != null){
            e.preventDefault();
            buttonClick.click();
        }
    })
}

//open country selector submenu mobile when clicked on whole link
if(countrySelectDeskBtn){
    for (let i = 0; i < countrySelectDeskBtn.length; i++) {
        const element = countrySelectDeskBtn[i];
        element.addEventListener("click",function(e){
            let buttonClick = element.nextElementSibling;
            if(buttonClick != null){
                e.preventDefault();
                buttonClick.click();
            }
        })
    }
}

//open language selector submenu mobile when clicked on whole link
if(mobLangSelectorBtn){
    mobLangSelectorBtn.addEventListener("click",function(e){
        e.preventDefault();
        let buttonClick = mobLangSelectorBtn.nextElementSibling;
        buttonClick.click();
    });
}

// check desktop nav active manu
if(getActiveLink.length == 0){
    let activeParentMenu = document.querySelector(".active-main-nav");
    if(activeParentMenu){
        activeParentMenu.classList.add("current-active-nav");
    }
}else {
    let parentActiveNav = getActiveLink[0].parentElement.closest(".main-nav-bar");
    if(parentActiveNav != null){
        parentActiveNav.classList.add("current-active-nav");
    } else {
        let activeParentMenu = document.querySelector(".active-main-nav");
        activeParentMenu.classList.add("current-active-nav");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    window.dispatchEvent(new Event('resize'));
});


window.onresize = function(event){
    if (document.querySelector('.tabby')) {
        let announcementHeight = document.querySelector('.ab-container').offsetHeight;
        let tabbyHeight = document.querySelector('.tabby').offsetHeight;
        let headerHeight = (announcementHeight + tabbyHeight);
        let headerWrapper = document.querySelector('.header-section-header').offsetHeight;
        let headerSection = (headerHeight + headerWrapper);
        document.querySelector('.header-inner-wrapper').style.top = headerHeight;
        document.querySelector('div#shopify-section-header').style.marginBottom = (headerSection -1) + 'px'; 
    }
}

